<script>
    export let placeholder
    export let label
    export let required
    export let id
    export let disabled
</script>

<label for={id} class="{disabled ? 'opacity-50' : ''} block mb-1">{label}{required ? '*' : ''}</label>
<textarea on:input disabled={disabled} id={id} name={id} class="{disabled ? 'opacity-50' : ''} p-2 border border-grey-500 rounded w-full" rows=5 placeholder={placeholder}></textarea>